
import { defineComponent } from 'vue';
import VInput from '@/components/vendor/basic/form/parts/VInput.vue';
import VInputMask from '@/components/vendor/basic/form/parts/VInputMask.vue';

export default defineComponent({
  name: 'VFormGroupInputText',
  components: {
    VInputMask,
    VInput,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    forKey: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    size: {
      type: String,
      required: false,
      default: null,
    },
    inputClass: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    autocomplete: {
      type: String,
      required: false,
      default: null,
    },
    yupErrorsVariable: {
      type: String,
      required: false,
      default: null,
    },
    mask: {
      type: Object,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {
    emitValue(value) {
      this.$emit('update:value', value);
    },
  },
});
